import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-query-counter',
  imports: [],
  templateUrl: './query-counter.component.html'
})
export class QueryCounterComponent {
  readonly totalRequests = input.required<number>();
  readonly totalAvailableRequests = input.required<number>();
  readonly showQuota = input.required<boolean>();
  readonly loading = input.required<boolean>();

  queryHeightPercent = computed(() => {
    return (this.totalRequests() / this.totalAvailableRequests()) * 100;
  });

  getGradientStyle(percent: number): { [key: string]: string } {
    // Se percent è maggiore di 0 ma minore di 1, mostra almeno 1
    const displayPercent = percent > 0 && percent < 1 ? 1 : percent;
    const color = this.getGradientColor(displayPercent);
    return {
      background: `linear-gradient(
      to top,
      ${color} 0%,
      ${color} ${displayPercent}%,
      white ${displayPercent}%,
      white 100%
    )`
    };
  }

  private getGradientColor(percent: number): string {
    if (percent < 50) {
      return '#E6F4EA'; // verde tenue
    } else if (percent < 80) {
      return '#FFF9DB'; // giallo tenue
    } else {
      return '#FDEDED'; // rosso tenue
    }
  }
}
